//#region Dependencies
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CURRENCY, DISPATCH_ID, FORMAT_NUMBER, SERVICE_RESPONSE, Sections } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import SeriesCreateModal from '../SeriesCreateModal';
import AccountListModal from '../AccountListModal';
import '../../css/responsive.css';
import { roundToDecimals } from "../../libs/utils/GlobalFunc";
import $ from "jquery";
import moment from "moment";
import Select from 'react-select';
let apiClient = ApiClient.getInstance();
//#endregion

export default function CollectDeposits(props) {
    //#region REDUX
    const dispatch = useDispatch();
    const notificationReducer = useSelector((store) => store.NotificationReducer);
    const { showAlert } = notificationReducer;
    const enableSpinner = (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value });
    //#endregion

    //#region Variables && Const Declaration
    const { cancel, ModelCollect = {}, writeAccess = false, cancelAndSearch, globalCurrency = CURRENCY, idSession, bankOptions = [], CFWOptions = [], toleranceInfo = [] } = props;
    const [cashTotal, setCashTotal] = useState(0);
    const [voucher, setVoucher] = useState({});
    const [voucherList, setVoucherList] = useState([]);
    const [selectedVoucher, setSelectedVoucher] = useState(-1);
    const [operations, setOperations] = useState([]);
    const [enableContinue, setEnableContinue] = useState(false);

    const [currentCheck, setCurrentCheck] = useState(null);
    const [TaxDate, setTaxDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [DocDate, setDocDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [DocDueDate, setDocDueDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [SerieName, setSerieName] = useState('');
    const [SerieCode, setSerieCode] = useState('');
    const [Series, setSeries] = useState('');
    const [NextFolio, setNextFolio] = useState('');
    const [showOpenSeriesModal, setShowOpenSeriesModal] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [accountMayorId, setAccountMayorId] = useState(null);
    const [showAccountListModal, setShowAccountListModal] = useState(false);
    const [perceptions, setPerceptions] = useState([]);
    const [invoicesTotal, setInvoicesTotal] = useState(0);
    const [perceptionsTotal, setPerceptionsTotal] = useState(0);
    const [sameSerie, setSameSerie] = useState(false);
    const [paymentsSummary, setPaymentsSummary] = useState([]);
    const [currencyRate, setCurrencyRate] = useState({ date: '', rate: 0 });
    const [validatingVoucher, setValidatingVoucher] = useState(false);
    const depositCurrency = voucherList[0]?.Currency || voucher.currency || (globalCurrency === CURRENCY ? 'PEN' : globalCurrency);
    const toBaseAmount = (amount, currency, rate = currencyRate.rate) =>
        Number((Number(amount) * (currency === 'USD' ? rate : 1) / (globalCurrency === 'USD' ? rate : 1)).toFixed(2));
    const depositRemaining = deposit =>
        Number((Number(deposit.Remaining || 0) * (deposit.BaseRate || 1) / (deposit.Currency === 'USD' ? deposit.ChangeRate_1 : 1)).toFixed(2));
    //#region Flujo de caja
    const [transferCFWOptions, setTransferCFWOptions] = useState([]);
    //#endregion Flujo de caja

    const checkOptions = [
        { label: "Exactitud", value: "E" },
        { label: "Parcialidad", value: "P" },
        { label: "Redondeo", value: "R" },
        { label: "A cuenta", value: "AC" },
    ];

    const operationFields = [
        { label: "Cliente", key: "cardCode" },
        { label: "N° Doc", key: "docNum" },
        { label: "No.Ref.: ", key: "numAtCard" },
        { label: "Fecha", key: "docDate" },

        // ORIGINAL
        { label: "Factura", key: "CashTotal", needFormat: true },
        { label: "Percepción", key: "auxU_PRC_IMP", needFormat: true },
        { label: "Total", key: "originalInvoiceTotal", needFormat: true },

        // APLICADO
        { label: "Aplicado Factura", key: "CashApplied", needFormat: true },
        { label: "Aplicado Percep.", key: "U_PRC_IMP", needFormat: true },
        { label: "Total Aplicado", key: "appliedTotal", needFormat: true },

        //CESION
        { label: "C. Uso", key: "MontoCU", needFormat: true },

        // RESTANTE REAL
        { label: "Restante", key: "remainingTotal", needFormat: true }
    ];

    //#endregion

    //#region On Component Init
    useEffect(() => {
        const getOperations = async () => {
            let operations = [];
            for (const doc of ModelCollect?.ItemsPayments) {
                const {
                    DocEntry = '',
                    DocNum = '',
                    CardCode = '',
                    NumAtCard = '',
                    DocDate = '',
                    PorVencer = 0,
                    TransId = null,
                    U_PRC_IMP = 0,
                    originalU_PRC_IMP = 0,
                    U_STR_FE_Tasa_Percepcion = 0,
                    auxOriginalU_PRC_IMP = 0,
                    auxU_STR_FE_Tasa_Percepcion = 0,
                    ObjType = '',
                    MontoCU = 0,
                    CUItem = null,
                } = doc ?? {};
                const auxU_PRC_IMP = U_PRC_IMP;

                const docInfo = {
                    // FACTURA
                    idSale: DocEntry,
                    docEntry: DocEntry,
                    docNum: DocNum,
                    docDate: moment(DocDate).isValid() ? moment(DocDate).format("DD/MM/YYYY") : "--",
                    cardCode: CardCode,
                    numAtCard: NumAtCard,
                    TransId,
                    ObjType,

                    // ORIGINAL
                    CashTotal: Number(PorVencer || 0),
                    originalU_PRC_IMP: Number(originalU_PRC_IMP || 0),
                    U_STR_FE_Tasa_Percepcion: Number(U_STR_FE_Tasa_Percepcion || 0),
                    auxOriginalU_PRC_IMP: Number(auxOriginalU_PRC_IMP || 0),
                    auxU_STR_FE_Tasa_Percepcion: Number(auxU_STR_FE_Tasa_Percepcion || 0),
                    originalInvoiceTotal: Number(PorVencer || 0) + Number(auxU_PRC_IMP || 0) + Number(MontoCU || 0),
                    auxU_PRC_IMP,

                    // APLICADO
                    CashApplied: 0,
                    U_PRC_IMP: 0,
                    appliedTotal: 0,

                    // RESTANTE
                    Remaining: Number(PorVencer || 0),
                    remainingTotal: Number(PorVencer || 0) + Number(auxU_PRC_IMP || 0) + Number(MontoCU || 0),
                    Amount: "0.00",

                    //CESION USO
                    MontoCU: Number(MontoCU || 0),
                    CUItem: CUItem ?? null,

                };
                operations.push(docInfo);
            }

            setSelectedVoucher(0);
            setOperations(operations);
            let CashTotal = 0;
            // CashTotal = (operations || []).reduce((acc, curr) => acc += (Number(curr.CashTotal) || 0), 0); // Esta linea daba error: eran 5675.8 pero regresaba 5675.800000000001
            CashTotal = (operations || []).reduce(
                (acc, curr) => acc + Math.round((Number(curr.CashTotal) || 0) * 100),
                0
            ) / 100;
            let auxU_PRC_IMP = 0;
            auxU_PRC_IMP = (operations || []).reduce((acc, curr) => acc += (Number(curr.auxU_PRC_IMP) || 0), 0);
            let auxMontoCU = 0;
            auxMontoCU = (operations || []).reduce((acc, curr) => acc += (Number(curr.MontoCU) || 0), 0);
            setInvoicesTotal(CashTotal);
            setPerceptionsTotal(auxU_PRC_IMP);
            setCashTotal(CashTotal + auxU_PRC_IMP + auxMontoCU);
        }

        setDefaultValues();
        getOperations();

        //#region Flujo de caja
        const transferCFWOptions = !Sections['FlujoCaja'] ? [] : mapCFWOptions(CFWOptions ?? []);
        setTransferCFWOptions(transferCFWOptions);
        //#endregion Flujo de caja
    }, []);

    useEffect(() => {
        if (showOpenSeriesModal) {
            $('#seriesDocumentsModal').modal('show');
        }
    }, [showOpenSeriesModal]);

    useEffect(() => {
        if (showAccountListModal) {
            $('#AccountListModal').modal('show');
        }
    }, [showAccountListModal]);

    useEffect(() => {
        let cancelled = false;
        const getRateChange = async () => {
            try {
                const response = await apiClient.getRateChange(DocDate);
                if (cancelled) return;
                if (response.status !== SERVICE_RESPONSE.SUCCESS) throw new Error(response.message || 'No se pudo consultar el tipo de cambio.');
                const rate = Number(response.data?.find(currency => currency.CurrCode === 'USD')?.Rate);
                const validRate = Number.isFinite(rate) && rate > 0;
                setCurrencyRate({ date: DocDate, rate: validRate ? rate : 0 });
                if (!validRate) {
                    if (depositCurrency === 'USD' || globalCurrency === 'USD') showAlert({ type: 'warning', message: `No hay tipo de cambio de USD para el ${DocDate}.` });
                    return;
                }
                setVoucherList(previous => previous.map(deposit => {
                    const total = toBaseAmount(deposit.TotalCurrency, deposit.Currency, rate);
                    return {
                        ...deposit, Total: total, Remaining: total,
                        BaseRate: globalCurrency === 'USD' ? rate : 1,
                        ChangeRate_1: deposit.Currency === 'USD' ? rate : 1,
                        operations: []
                    };
                }));
                setOperations(previous => previous.map(operation => ({
                    ...operation, CashApplied: 0, U_PRC_IMP: 0, appliedTotal: 0,
                    Remaining: operation.originalInvoiceTotal, remainingTotal: operation.originalInvoiceTotal, Amount: '0.00'
                })));
                setEnableContinue(false);
            } catch (error) {
                if (cancelled) return;
                setCurrencyRate({ date: '', rate: 0 });
                showAlert({ type: 'error', message: error.message || 'No se pudo consultar el tipo de cambio.' });
            }
        };
        getRateChange();
        // Ignorar la respuesta anterior si cambia la fecha o se cierra el componente.
        return () => { cancelled = true; };
    }, [DocDate]);
    //#endregion

    //#region ModalsActions
    const closeModals = async (search = false) => {
        $("#CollectDepositsModal").modal("hide");
        $("#LinkOperationsModal").modal("hide");
        $("#continueCollectModal").modal("hide");
        $("#cancelModal").modal("hide");
        $('#seriesDocumentsModal').modal('hide');
        $('#AccountListModal').modal('hide');
        $('#confirmBackModal').modal('hide');
        $('#perceptionsModal').modal('hide');
        $('#editDepositModal').modal('hide');
        $('#paymentsSummaryModal').modal('hide');

        if (search) {
            setTimeout(cancelAndSearch(2), 500);
        } else {
            setTimeout(cancel, 500);
        }
    };

    const setDefaultValues = () => {
        setVoucher({
            number: "",
            bank: "",
            date: moment().format("YYYY-MM-DD"),
            currency: depositCurrency,
            total: "0.00",
            U_RS_CODAPR: '',
            TransferAccount: '',
            needTransferCFW: false,
            transferCFWId: null,
        });
    }

    const validateVoucher = async () => {
        if (!writeAccess) { return showAlert({ type: "error", message: "TU PERFIL NO TIENE PERMISO PARA REALIZAR ESTA ACCIÓN", timeOut: 8000 }); }
        const vouchersTotal = voucherList.reduce((acc, current) => acc += Number(current.Total), 0);
        if (!voucher.number) { return showAlert({ type: "warning", message: "Ingrese un Numero de movimiento valido" }); }
        if (!voucher.bank) { return showAlert({ type: "warning", message: "Ingrese un Banco valido" }); }
        if (!moment(voucher.date || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha valida" }); }
        if (!voucher.currency) { return showAlert({ type: "warning", message: "Ingrese una moneda valida" }); }
        if (voucherList.length && voucher.currency !== voucherList[0].Currency) {
            return showAlert({ type: 'warning', message: 'Todos los depósitos deben usar la misma moneda.' });
        }
        if ((voucher.currency === 'USD' || globalCurrency === 'USD') && (currencyRate.date !== DocDate || currencyRate.rate <= 0)) {
            return showAlert({ type: 'warning', message: 'No hay un tipo de cambio válido para la fecha de contabilización.' });
        }

        if (!Number(`${voucher.total || 0}`.replace(/,/g, ""))) { return showAlert({ type: "warning", message: "Ingrese un Total valido" }); }

        if (voucherList.some( // El quiebre es por todos los siguientes datos, ya que un número de referencia con el mismo monto, moneda y banco puede estar en 2 depositos pero con fechas diferentes
            ({ Number: voucherNumber, Bank, Date: voucherDate, Currency, Total, TotalCurrency }) =>
                `${voucherNumber || ""}` === `${voucher.number || ""}` &&
                Bank === voucher.bank &&
                moment(voucherDate).format("YYYY-MM-DD") === moment(voucher.date).format("YYYY-MM-DD") &&
                Currency === voucher.currency &&
                Number(`${TotalCurrency ?? Total ?? 0}`.replace(/,/g, "")) === Number(`${voucher.total ?? 0}`.replace(/,/g, ""))
        )) {
            return showAlert({ type: "warning", message: "Ya se encuentra registrado este depósito en la operación" });
        }

        const currentValue = toBaseAmount(Number(`${voucher.total || 0}`.replace(/,/g, "")), voucher.currency);
        const newTotal = vouchersTotal + currentValue;
        if (!currentCheck) { return showAlert({ type: "warning", message: "Debe seleccionar Exactitud, Parcialidad, Redondeo o A cuenta." }); }
        if (currentCheck === 'E' && newTotal > cashTotal) { return showAlert({ type: "warning", message: "El monto depositado no puede superar el total de las facturas." }); }
        if (currentCheck === 'P' && newTotal >= cashTotal) { return showAlert({ type: "warning", message: "El monto depositado debe ser menor al total de las facturas." }); }

        //#region Validación antigüedad
        const hasOldDocs = voucher.date && moment().diff(moment(voucher.date), 'days') > 3;
        if (hasOldDocs && !voucher.U_RS_CODAPR) { return showAlert({ type: "warning", message: "No puede registrar cobros de documentos con más de 3 días de antigüedad. Ingrese un código de aprobación." }); }
        if (!hasOldDocs) { setVoucher({ ...voucher, U_RS_CODAPR: "" }); }
        //#endregion Validación antigüedad
        if (!voucher.TransferAccount) { return showAlert({ type: "warning", message: "Debe de seleccionar una Cuenta a mayor" }); }

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && voucher?.TransferAccount && voucher?.needTransferCFW && !voucher?.transferCFWId) { return showAlert({ type: "warning", message: `Debe especificar el "Flujo de caja" para el depósito ${voucher.number}` }); }
        //#endregion Flujo de caja

        setValidatingVoucher(true);
        enableSpinner(true)
        let apiResponse;
        try {
            apiResponse = await apiClient.validateVoucher({ voucher, isCollectView: true });
        } finally {
            enableSpinner(false);
            setValidatingVoucher(false);
        }

        if (apiResponse.status !== SERVICE_RESPONSE.SUCCESS) {
            return showAlert({ type: "error", message: apiResponse.message || "Error al conectar con el servidor, intente más tarde" });
        }

        const totalCurrency = Number(`${voucher.total}`.replace(/,/g, ''));
        const total = toBaseAmount(totalCurrency, voucher.currency);
        setVoucherList([...voucherList, {
            ...apiResponse.data,
            Currency: voucher.currency,
            TotalCurrency: totalCurrency,
            Total: total,
            Remaining: total,
            BaseRate: globalCurrency === 'USD' ? currencyRate.rate : 1,
            ifChangeRate: voucher.currency === 'USD',
            ChangeRate_1: voucher.currency === 'USD' ? currencyRate.rate : 1,
            operations: []
        }]);
        setDefaultValues();
    };

    const verifyVoucherList = async () => {

        if (!writeAccess) { return showAlert({ type: "error", message: "TU PERFIL NO TIENE PERMISO PARA REALIZAR ESTA ACCIÓN", timeOut: 8000 }); }
        if (!voucherList?.length) { return showAlert({ type: "warning", message: "Debe de registrar depósitos bancarios para poder continuar.", timeOut: 8000 }); }
        if ((depositCurrency === 'USD' || globalCurrency === 'USD') && (currencyRate.date !== DocDate || currencyRate.rate <= 0)) {
            return showAlert({ type: 'warning', message: 'No hay un tipo de cambio válido para la fecha de contabilización.' });
        }
        if (!SerieCode) { return showAlert({ type: "warning", message: "Selecciona una serie válida", timeOut: 8000 }); }
        if (!moment(DocDate || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha válida para el campo F. Contabilización", timeOut: 8000 }) }
        if (!moment(DocDueDate || "").isValid()) { return showAlert({ type: "warning", message: "Ingrese una fecha válida para el campo F. Vencimiento", timeOut: 8000 }) }

        const round2 = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
        const vouchersTotal = round2(
            voucherList?.reduce((acc, current) => acc += Number(current.Total), 0)
        );
        const newCashTotal = round2(cashTotal);
        const currency = globalCurrency || CURRENCY;
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
        const TOLERANCE = Number(currentTolerance?.MaxInDiff ?? 0); // Esto es para currentCheck en AC

        if (!currentCheck) { return showAlert({ type: "warning", message: "Debe seleccionar Exactitud, Parcialidad, Redondeo o A cuenta.", timeOut: 8000 }); }

        //#region Check Seleccionado
        if (currentCheck === 'E' && vouchersTotal !== newCashTotal) { return showAlert({ type: "warning", message: "El total de los depósitos debe ser exactamente igual al total de las facturas.", timeOut: 8000 }); }
        if (currentCheck === 'P' && vouchersTotal >= newCashTotal) { return showAlert({ type: "warning", message: "El total de los depósitos debe ser menor al total de las facturas.", timeOut: 8000 }); }
        if (currentCheck === 'AC' && vouchersTotal <= (newCashTotal + TOLERANCE)) { return showAlert({ type: "warning", message: "El total de los depósitos, debe ser mayor al total de las facturas + tolerancia de redondeo.", timeOut: 8000 }); }
        //#endregion Check Seleccionado

        await $("#CollectDepositsModal").modal("hide");
        await $("#LinkOperationsModal").modal("show");
    };

    const changeCFW = async (event = null, type = 1, isEdit = false) => {
        const value = event?.value ?? null;

        const cfwFields = {
            1: 'transferCFWId',
            2: 'cashCFWId',
            3: 'checkCFWId'
        };

        const field = cfwFields[type];

        if (!field) return;

        if (isEdit) {
            setVoucherList(prev =>
                prev.map((v, i) =>
                    i === selectedVoucher
                        ? { ...v, [field]: value }
                        : v
                )
            );
        } else {
            setVoucher(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const mapCFWOptions = (options = []) =>
        options.map(cfw => ({
            value: cfw.CFWId,
            label: `${cfw.CFWId} - ${cfw.CFWName}`
        }));

    const saveEdition = () => {
        if (!voucherList?.[selectedVoucher]?.TransferAccount) {
            return showAlert({ type: "warning", message: "Debe de seleccionar una Cuenta a mayor", timeOut: 8000 });
        }

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && voucherList?.[selectedVoucher]?.TransferAccount && voucherList?.[selectedVoucher]?.needTransferCFW && !voucherList?.[selectedVoucher]?.transferCFWId) {
            return showAlert({ type: "warning", message: `Debe especificar el "Flujo de caja" para el depósito` });
        }
        //#endregion Flujo de caja

        $("#editDepositModal").modal("hide")
    }

    const changeAmountOperation = (value, index) => {
        let auxOperations = JSON.parse(JSON.stringify(operations));
        auxOperations[index].Amount = value;
        setOperations(auxOperations);
    };

    const addOperation = (index) => {

        const round2 = (n) => Number(Number(n || 0).toFixed(2));

        let auxOperations = JSON.parse(JSON.stringify(operations));
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));

        let operation = auxOperations[index];
        let voucher = auxVoucherList[selectedVoucher];

        const amount = Number(`${operation.Amount || 0}`.replace(/,/g, ""));
        if (!amount) {
            return showAlert({ type: "warning", message: "Ingrese un Total valido" });
        }

        if (amount > operation.remainingTotal) {
            return showAlert({ type: "warning", message: "El monto supera la cantidad de la operación" });
        }

        const baseFactura = round2(operation.CashTotal);
        const basePercep = round2(operation.auxU_PRC_IMP);
        const totalOriginal = round2(operation.originalInvoiceTotal);

        let cashApplied = 0;
        let perceptionApplied = 0;

        // Separar proporcionalmente
        if (basePercep > 0 && totalOriginal > 0) {

            if (amount >= operation.remainingTotal) {
                cashApplied = round2(baseFactura - operation.CashApplied);
                perceptionApplied = round2(basePercep - operation.U_PRC_IMP);
            } else {
                cashApplied = round2(amount * (baseFactura / totalOriginal));
                perceptionApplied = round2(amount - cashApplied);
            }

        } else {
            cashApplied = round2(amount);
            perceptionApplied = 0;
        }

        const appliedTotal = round2(cashApplied + perceptionApplied);

        // Buscar si ya existe en voucher
        const subIndex = voucher?.operations?.findIndex(o => o.idSale === operation.idSale);

        if (subIndex !== -1) {
            voucher.operations[subIndex].CashApplied += cashApplied;
            voucher.operations[subIndex].U_PRC_IMP += perceptionApplied;
            voucher.operations[subIndex].appliedTotal += appliedTotal;
        } else {
            voucher.operations.push({
                ...operation,
                CashApplied: cashApplied,
                U_PRC_IMP: perceptionApplied,
                appliedTotal
            });
        }

        // Actualizar operación global
        operation.CashApplied = round2(operation.CashApplied + cashApplied);
        operation.U_PRC_IMP = round2(operation.U_PRC_IMP + perceptionApplied);
        operation.appliedTotal = round2(operation.CashApplied + operation.U_PRC_IMP);

        operation.remainingTotal = round2(operation.originalInvoiceTotal - operation.appliedTotal);
        operation.Remaining = operation.remainingTotal;

        // Actualizar voucher
        let remaining = round2(
            voucher.Total -
            voucher.operations.reduce((acc, curr) => acc + Number(curr.appliedTotal || 0), 0)
        );

        if (remaining < 0) {
            return showAlert({ type: "warning", message: "El monto supera la cantidad del depósito" });
        }

        voucher.Remaining = remaining;
        operation.Amount = "";

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);

        let TOLERANCE = 0;
        const currency = globalCurrency || CURRENCY;
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
        if (currentCheck === 'AC') {
            TOLERANCE = Number(currentTolerance?.MaxInDiff ?? 0); // Esto es para currentCheck en AC
            const hasRemainingInvoices = auxOperations.some(o => // Todas las facturas deben estar cubiertas
                round2(o.remainingTotal) > TOLERANCE
            );
            const hasRemainingVouchers = auxVoucherList.some(v => // Debe existir al menos un depósito con saldo restante
                round2(v.Remaining) > TOLERANCE
            );
            setEnableContinue(!hasRemainingInvoices && hasRemainingVouchers);
            return;
        }

        const hasPending = auxVoucherList.some(v => {
            const remaining = round2(v.Remaining);
            TOLERANCE = remaining > 0
                ? Number(currentTolerance?.MaxOutDiff ?? 0)  // Falta
                : Number(currentTolerance?.MaxInDiff ?? 0);  // Sobra

            return Math.abs(remaining) > (currentCheck === 'R' ? TOLERANCE : 0);
        });
        setEnableContinue(!hasPending);
    };

    const removeOperation = (cOperation, index) => {

        const round2 = (n) => Number(Number(n || 0).toFixed(2));

        let auxOperations = JSON.parse(JSON.stringify(operations));
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));

        let operation = auxOperations.find(o => o.idSale === cOperation.idSale);
        let voucher = auxVoucherList[selectedVoucher];
        voucher.operations.splice(index, 1);

        const appliedTotal = round2(cOperation.appliedTotal || 0);
        const cashApplied = round2(cOperation.CashApplied || 0);
        const perceptionApplied = round2(cOperation.U_PRC_IMP || 0);

        // Devolver al voucher
        voucher.Remaining = round2(voucher.Remaining + appliedTotal);

        // Devolver a la operación
        operation.CashApplied = round2(operation.CashApplied - cashApplied);
        operation.U_PRC_IMP = round2(operation.U_PRC_IMP - perceptionApplied);

        operation.appliedTotal = round2(operation.CashApplied + operation.U_PRC_IMP);
        operation.remainingTotal = round2(operation.originalInvoiceTotal - operation.appliedTotal);
        operation.Remaining = operation.remainingTotal;

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);

        if (currentCheck === 'AC') {
            const currency = globalCurrency || CURRENCY;
            const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
            const TOLERANCE = Number(currentTolerance?.MaxInDiff ?? 0); // Esto es para currentCheck en AC

            const hasRemainingInvoices = auxOperations.some(o => // Todas las facturas deben estar cubiertas
                round2(o.remainingTotal) > TOLERANCE
            );
            const hasRemainingVouchers = auxVoucherList.some(v => // Debe existir al menos un depósito con saldo restante
                round2(v.Remaining) > TOLERANCE
            );
            setEnableContinue(!hasRemainingInvoices && hasRemainingVouchers);
            return;
        }

        setEnableContinue(false);
    };

    const removeDeposit = (cVoucher, index) => {
        const auxVoucherList = [...voucherList];
        auxVoucherList.splice(index, 1);

        setVoucherList(auxVoucherList);
    };

    const processCollectPayments = async () => {
        const round2 = (value) => Number(Number(value || 0).toFixed(2));

        const getOriginalInvoiceTotal = (op) => {
            return round2(
                op?.originalInvoiceTotal ??
                (Number(op?.CashTotal || 0) + Number(op?.auxU_PRC_IMP || 0))
            );
        };

        const splitAppliedAmount = (appliedTotal, op) => {
            const cashTotal = round2(op?.CashTotal);
            const perceptionTotal = round2(op?.auxU_PRC_IMP);
            const originalTotal = round2(op?.originalInvoiceTotal ?? (cashTotal + perceptionTotal));

            if (appliedTotal <= 0 || originalTotal <= 0) {
                return { cashApplied: 0, perceptionApplied: 0 };
            }

            // Si no tiene percepción, todo va a factura
            if (perceptionTotal <= 0 || cashTotal <= 0) {
                return { cashApplied: round2(appliedTotal), perceptionApplied: 0 };
            }

            // Si cubre el total completo, cerrar exacto
            if (round2(appliedTotal) >= round2(originalTotal)) {
                return {
                    cashApplied: cashTotal,
                    perceptionApplied: perceptionTotal
                };
            }

            // Reparto proporcional sobre el total original
            const cashApplied = round2(appliedTotal * (cashTotal / originalTotal));
            const perceptionApplied = round2(appliedTotal - cashApplied);

            return { cashApplied, perceptionApplied };
        };

        const applyToOperation = (op, appliedTotal) => {
            const { cashApplied, perceptionApplied } = splitAppliedAmount(appliedTotal, op);

            op.CashApplied = round2(op.CashApplied + cashApplied);
            op.U_PRC_IMP = round2(op.U_PRC_IMP + perceptionApplied);
            op.appliedTotal = round2(op.CashApplied + op.U_PRC_IMP);

            op.Remaining = round2(op.Remaining - appliedTotal);
            op.remainingTotal = op.Remaining;

            return { cashApplied, perceptionApplied };
        };

        // EXACT MATCH
        const findExactMatchIndex = (ops, voucherAmount) => {
            return ops.findIndex(op => round2(op.Remaining) === round2(voucherAmount));
        };

        // CLOSEST MATCH
        const findClosestMatchIndex = (ops, voucherAmount) => {
            let bestIndex = -1;
            let minDiff = Infinity;

            ops.forEach((op, idx) => {
                const remaining = round2(op.Remaining);
                if (remaining <= 0) return;

                const diff = Math.abs(remaining - voucherAmount);

                if (diff < minDiff) {
                    minDiff = diff;
                    bestIndex = idx;
                }
            });

            return bestIndex;
        };

        try {
            enableSpinner(true);
            //#region Evitar reprocesar
            const hasSelections = voucherList?.some(v => Array.isArray(v.operations) && v.operations?.length > 0);
            if (hasSelections) return;
            //#endregion Evitar reprocesar

            const totalInvoices = (operations || []).reduce((acc, o) => acc + getOriginalInvoiceTotal(o), 0);
            const totalVouchers = (voucherList || []).reduce((acc, v) => acc + Number(v.Total || 0), 0);

            // EXACTITUD GLOBAL
            if (currentCheck === 'E') {
                if (round2(totalInvoices) !== round2(totalVouchers)) {
                    setOperations([]);
                    setVoucherList((voucherList || []).map(v => ({ ...v, operations: [], Remaining: round2(v.Total || 0) })));
                    setEnableContinue(false);
                    return;
                }
            }

            // Clonar data
            let auxOperations = (operations || []).map(op => {
                const originalInvoiceTotal = getOriginalInvoiceTotal(op);

                return {
                    ...op,
                    CashApplied: 0,
                    U_PRC_IMP: 0,
                    appliedTotal: 0,
                    Remaining: originalInvoiceTotal,
                    remainingTotal: originalInvoiceTotal,
                    originalInvoiceTotal
                };
            });

            let auxVouchers = (voucherList || []).map(v => ({
                ...v,
                operations: [],
                Remaining: round2(v.Total || 0)
            }));

            // PROCESO PRINCIPAL
            for (const voucher of auxVouchers) {
                let remainingVoucher = round2(voucher.Remaining);

                if (currentCheck === 'R' && remainingVoucher > 0) {

                    // EXACT MATCH
                    let index = findExactMatchIndex(auxOperations, remainingVoucher);

                    // CLOSEST MATCH
                    if (index === -1) {
                        index = findClosestMatchIndex(auxOperations, remainingVoucher);
                    }

                    if (index !== -1) {
                        // Recorrido circular
                        const orderedOps = [
                            ...auxOperations.slice(index),
                            ...auxOperations.slice(0, index)
                        ];

                        for (const op of orderedOps) {
                            if (remainingVoucher <= 0) break;
                            if (round2(op.Remaining) <= 0) continue;

                            const opRemaining = round2(op.Remaining);

                            const appliedTotal = remainingVoucher >= opRemaining
                                ? opRemaining
                                : remainingVoucher;

                            const { cashApplied, perceptionApplied } = applyToOperation(op, appliedTotal);

                            remainingVoucher = round2(remainingVoucher - appliedTotal);

                            const operationCopy = JSON.parse(JSON.stringify(op));
                            operationCopy.CashApplied = cashApplied;
                            operationCopy.U_PRC_IMP = perceptionApplied;
                            operationCopy.appliedTotal = round2(cashApplied + perceptionApplied);
                            operationCopy.Remaining = round2(op.Remaining);

                            voucher.operations.push(operationCopy);
                        }

                        voucher.Remaining = round2(remainingVoucher);

                        continue;
                    }
                }

                // FLUJO NORMAL (E / P / fallback de R)
                for (const op of auxOperations) {
                    if (remainingVoucher <= 0) break;
                    if (round2(op.Remaining) <= 0) continue;

                    const opRemaining = round2(op.Remaining);

                    // Monto total que se le aplica a la operación desde este depósito
                    const appliedTotal = remainingVoucher >= opRemaining ? opRemaining : remainingVoucher;

                    // Separar factura vs percepción
                    const { cashApplied, perceptionApplied } = applyToOperation(op, appliedTotal);

                    remainingVoucher = round2(remainingVoucher - appliedTotal);

                    // Copia para el voucher actual (solo lo aplicado en ESTE depósito)
                    const operationCopy = JSON.parse(JSON.stringify(op));
                    operationCopy.CashApplied = cashApplied;
                    operationCopy.U_PRC_IMP = perceptionApplied;
                    operationCopy.appliedTotal = round2(cashApplied + perceptionApplied);
                    operationCopy.Remaining = round2(op.Remaining);

                    voucher.operations.push(operationCopy);
                }

                voucher.Remaining = round2(remainingVoucher);
            }

            // VALIDACIÓN EXACTA FINAL
            if (currentCheck === 'E') {
                const hasRemainingInvoices = auxOperations.some(o => round2(o.Remaining) > 0);
                const hasRemainingVouchers = auxVouchers.some(v => round2(v.Remaining) > 0);

                if (hasRemainingInvoices || hasRemainingVouchers) {
                    setOperations([]);
                    setVoucherList(auxVouchers);
                    setEnableContinue(false);
                    return;
                }
            }

            setOperations(auxOperations);
            setVoucherList(auxVouchers);

            let TOLERANCE = 0;
            const currency = globalCurrency || CURRENCY;
            const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
            if (currentCheck === 'AC') {
                TOLERANCE = Number(currentTolerance?.MaxInDiff ?? 0); // Esto es para currentCheck en AC
                const hasRemainingInvoices = auxOperations.some(o => // Todas las facturas deben quedar cubiertas
                    round2(o.Remaining) > TOLERANCE
                );
                const hasRemainingVouchers = auxVouchers.some(v => // Debe existir al menos un depósito con saldo restante
                    round2(v.Remaining) > TOLERANCE
                );
                setEnableContinue(!hasRemainingInvoices && hasRemainingVouchers);
                return;
            }

            const hasPending = auxVouchers.some(v => {
                const remaining = round2(v.Remaining);
                TOLERANCE = remaining > 0
                    ? Number(currentTolerance?.MaxOutDiff ?? 0)  // Falta
                    : Number(currentTolerance?.MaxInDiff ?? 0);  // Sobra

                return Math.abs(remaining) > (currentCheck === 'R' ? TOLERANCE : 0);
            });

            setEnableContinue(!hasPending);
        } catch (error) {
            setEnableContinue(false);
        } finally {
            enableSpinner(false);
        }
    };

    const payments = async () => {
        const round2 = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
        let auxVoucherList = JSON.parse(JSON.stringify(voucherList));
        const OperationsList = voucherList;
        let summary = [];

        const currency = globalCurrency || CURRENCY;
        const currentTolerance = toleranceInfo?.find(t => t.CurrCode === currency || t.DocCurrCod === currency || t.ISOCurrCod === currency) ?? {};
        //#region VALIDACIÓN REDONDEO
        if (currentCheck === 'R') {
            let invalidDeposits = [];
            let hasError = false;

            for (const model of OperationsList) {
                let voucher = auxVoucherList.find(({ Number }) => Number === model.Number);
                if (!voucher) continue;

                let restante = round2(voucher?.Remaining ?? 0); // Solo para este caso la variable contiene lo que sobra. Para este caso primero debe de ir MaxInDiff
                const TOLERANCE = restante > 0
                    ? Number(currentTolerance?.MaxInDiff ?? 0)
                    : Number(currentTolerance?.MaxOutDiff ?? 0);

                if (Math.abs(restante) > TOLERANCE) {
                    hasError = true;
                    invalidDeposits.push({
                        Number: model.Number,
                        restante
                    });
                }
            }

            if (hasError) {
                return showAlert({
                    type: "warning",
                    message: `Los siguientes depósitos no cumplen con la tolerancia permitida para Redondeo: ${invalidDeposits
                        .map(d => `${d.Number} (restante: ${d.restante})`)
                        .join(', ')}`
                });
            }
        }
        //#endregion

        //#region DETECCIÓN DE REDONDEO (ÚLTIMO DEPÓSITO POR FACTURA)
        let roundingAssignments = [];

        if (currentCheck === 'R') {
            const operationsByInvoice = {};

            auxVoucherList.forEach(voucher => {
                (voucher.operations || []).forEach(op => {
                    const key = String(op.idSale);

                    if (!operationsByInvoice[key]) {
                        operationsByInvoice[key] = [];
                    }

                    operationsByInvoice[key].push({
                        voucherNumber: voucher.Number,
                        remaining: round2(op.remainingTotal || 0),
                        op
                    });
                });
            });

            Object.entries(operationsByInvoice).forEach(([idSale, ops]) => {
                const invoiceOperations = ops.map(x => x.op);
                const totalApplied = round2(
                    invoiceOperations.reduce(
                        (sum, op) => sum + Number(op.auxCashApplied ?? op.CashApplied ?? 0),
                        0
                    )
                );

                const invoiceTotal = round2(
                    Number(invoiceOperations[0]?.CashTotal ?? 0)
                );

                const difference = round2(invoiceTotal - totalApplied);
                if (difference <= 0) {
                    return;
                }

                const TOLERANCE = Number(currentTolerance?.MaxOutDiff ?? 0);
                if (difference > TOLERANCE) {
                    return;
                }

                const opsWithRemaining = ops.filter(o => o.remaining > 0);

                if (!opsWithRemaining.length) {
                    return;
                }

                const lastOp = opsWithRemaining[opsWithRemaining.length - 1];

                roundingAssignments.push({
                    voucherNumber: lastOp.voucherNumber,
                    idSale: Number(idSale),
                    amount: difference
                });
            });
        }

        //#endregion

        //#region APLICAR REDONDEO (IDEMPOTENTE)
        if (currentCheck === 'R') {
            OperationsList.forEach(model => {
                if (!Array.isArray(model.operations)) return;

                model.operations = model.operations.map(op => {

                    // BASE ORIGINAL (si hay un error y se vuelve a mandar al back no se aplique redondeo de mas)
                    const baseCash = round2(op.auxCashApplied ?? op.CashApplied);

                    const rounding = roundingAssignments.find(r =>
                        String(r.idSale) === String(op.idSale) &&
                        String(r.voucherNumber) === String(model.Number)
                    );

                    if (rounding) {

                        const newCashApplied = round2(baseCash + rounding.amount);

                        return {
                            ...op,
                            auxCashApplied: baseCash,
                            CashApplied: newCashApplied,
                            appliedTotal: newCashApplied
                        };
                    }

                    return {
                        ...op,
                        auxCashApplied: baseCash
                    };
                });

                model.isRounded = model.operations.some(op =>
                    roundingAssignments.some(r =>
                        String(r.idSale) === String(op.idSale) &&
                        String(r.voucherNumber) === String(model.Number)
                    )
                );
            });
        }
        //#endregion

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && OperationsList?.length) {
            let missingCFWId = false;
            for (const element of OperationsList) {
                if (element?.TransferAccount) {
                    if (element?.needTransferCFW && !element?.transferCFWId) {
                        showAlert({ type: "warning", message: `No es posible crear el pago. Debe especificar el "Flujo de caja" para el depósito ${element.Number}`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                }
            }

            if (missingCFWId) { // No se completó la información de Flujo de caja
                return;
            }
        }
        //#endregion Flujo de caja

        for (const model of OperationsList) {
            let voucher = auxVoucherList.find(({ Number }) => Number === model.Number);
            if (voucher?.Completed) continue;

            model.SerieCode = SerieCode;
            model.Series = Series;
            model.DocDate = DocDate;
            model.DueDate = DocDueDate;
            model.TaxDate = TaxDate;
            model.DocCurrency = model.Currency === 'PEN' ? CURRENCY : model.Currency;
            model.InvoicesCurrency = globalCurrency;

            const perceptionRow = perceptions?.find(row => String(row.voucherNumber) === String(voucher.Number));
            model.U_BPP_MDTDPaymentDefault = perceptionRow?.U_BPP_MDTDPaymentDefault ?? null;
            model.U_BPP_PTSCPaymentDefault = perceptionRow?.U_BPP_PTSCPaymentDefault ?? null;
            model.currentCheck = currentCheck;
            model.auxCardCode = ModelCollect?.CardCode ?? '';
            model.idSession = idSession;

            showAlert({ type: "info", message: `Aplicando el depósito: ${model.Number}` });

            enableSpinner(true);
            const apiResponse = await apiClient.collectPayments({ model });
            enableSpinner(false);

            const docNum = apiResponse?.data?.DocNum ?? '';
            const perceptionNumber = [
                apiResponse?.data?.U_BPP_MDTD,
                apiResponse?.data?.U_BPP_PTSC,
                apiResponse?.data?.U_BPP_PTCC
            ].filter(Boolean).join('-');
            const hasPerception = apiResponse?.data?.hasPerception || false;
            const isSuccess = apiResponse?.status;

            summary.push({
                voucherNumber: voucher.Number,
                paymentDocNum: docNum || "",
                perceptionNumber,
                hasPerception,
                paymentMessage: apiResponse?.message || "",
                status: isSuccess ? "success" : "error"
            });
        }

        setPaymentsSummary(summary);
        setSelectedVoucher(-1);

        const summaryMap = Object.fromEntries(
            summary.map(s => [String(s.voucherNumber), s])
        );

        const updatedVouchers = voucherList.map(v => {
            const found = summaryMap[String(v.Number)];

            return {
                ...v,
                paymentStatus: found?.status || null,
                paymentDocNum: found?.paymentDocNum || ""
            };
        });

        setVoucherList(updatedVouchers);
        showPaymentsSummary();
    };

    const SelectDocDate = async event => {
        if (validatingVoucher) return;
        let today = moment(new Date()).format('YYYY-MM-DD');
        let value = event.target.value;
        if (!moment(value, 'YYYY-MM-DD', true).isValid()) return;
        if (voucherList.some(deposit => deposit.Completed || deposit.paymentStatus === 'success')) {
            return showAlert({ type: 'warning', message: 'La fecha de un depósito aplicado no se puede modificar.' });
        }
        if (value > today) {
            showAlert({
                type: 'error',
                message: 'La fecha de contabilización tiene que ser igual o menor al día actual',
            });
            return;
        }
        setDocDate(value);
        setTaxDate(value);
    };

    const SelectDocDueDate = async event => {
        const value = event.target.value;
        setDocDueDate(value);
    };

    const OpenSeries = async () => {
        if (ModelCollect?.SerieArray?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        setShowOpenSeriesModal(true);
    };

    const SelectSeries = action => {
        let serie = ModelCollect.SerieArray[action.index];
        setSerieName(serie.SeriesName || '');
        setSerieCode(serie.Series || '');
        setNextFolio(serie.NextNumber || '');
        setSeries(serie.Series || '');
        $('#seriesDocumentsModal').modal('hide');
        setShowOpenSeriesModal(false);
    };

    const openCuentaMayor = async (index = null, cuenta) => {
        let data = {
            Currency: '',
            Type: '',
        }
        enableSpinner(true);
        let response = await apiClient.getCuentaMayor(data);
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setAccounts(response?.data);
        setAccountMayorId(cuenta);
        setShowAccountListModal(true);
    };

    const selectAccountList = action => {
        let account = accounts[action?.index];
        let needCFW = account?.CfwRlvnt === 'Y' && account?.Finanse === 'Y';

        if (accountMayorId === 1) {
            setVoucherList(prev =>
                prev.map((v, i) =>
                    i === selectedVoucher
                        ? {
                            ...v,
                            TransferAccount: account?.AcctCode || '',
                            TrsfrAcctName: account?.AcctName || '',
                            TrsfrAcctFormatCode: account?.FormatCode || '',
                            //#region Flujo de caja
                            needTransferCFW: needCFW,
                            transferCFWId: null
                            //#endregion Flujo de caja
                        }
                        : v
                )
            );
        }

        if (accountMayorId === 2) {
            setVoucher({
                ...voucher,
                TransferAccount: account?.AcctCode || '',
                TrsfrAcctName: account?.AcctName || '',
                TrsfrAcctFormatCode: account?.FormatCode || '',
                //#region Flujo de caja
                needTransferCFW: needCFW,
                transferCFWId: null
                //#endregion Flujo de caja
            })
        }

        if ([1, 2]?.includes(accountMayorId) && needCFW) {
            showAlert({ type: 'info', message: 'Por favor especifique el "Flujo de caja" para el depósito' });
        }

        $('#AccountListModal').modal('hide');
        setAccounts([]);
        setAccountMayorId(null);
        setShowAccountListModal(false);
    };

    const closeAccountListModal = action => {
        setShowAccountListModal(false);
    }

    const closeSeriesCreateModal = action => {
        setShowOpenSeriesModal(false);
    }

    const goBack = () => {
        if (hasSelectedInvoices()) {
            $("#confirmBackModal").modal("show");
        } else {
            $("#LinkOperationsModal").modal("hide");
            $("#CollectDepositsModal").modal("show")
        }
    };

    const hasSelectedInvoices = () => {
        return voucherList.some(v =>
            Array.isArray(v.operations) && v.operations.length > 0
        );
    };

    const confirmGoBack = () => {

        const round2 = (n) => Number(Number(n || 0).toFixed(2));

        let auxOperations = operations?.map(op => {

            const originalInvoiceTotal = round2(
                op.originalInvoiceTotal ??
                (Number(op.CashTotal || 0) + Number(op.auxU_PRC_IMP || 0))
            );

            return {
                ...op,
                CashApplied: 0,
                U_PRC_IMP: 0,
                appliedTotal: 0,
                Remaining: originalInvoiceTotal,
                remainingTotal: originalInvoiceTotal,
                Amount: "0.00"
            };
        });

        let auxVoucherList = voucherList?.map(v => ({
            ...v,
            operations: [],
            Remaining: round2(v.Total || 0)
        }));

        setOperations(auxOperations);
        setVoucherList(auxVoucherList);
        setEnableContinue(false);

        $("#confirmBackModal").modal("hide");
        $("#LinkOperationsModal").modal("hide");
        $("#CollectDepositsModal").modal("show");
    };

    const checkPerceptions = () => {
        let newPerceptions = [];

        voucherList.forEach((voucher, vIndex) => {
            if (!Array.isArray(voucher?.operations)) return;

            const hasPerception = voucher?.operations?.some(invoice => Number(invoice?.U_PRC_IMP) > 0);

            if (hasPerception) {
                newPerceptions.push({
                    // Depósito
                    voucherNumber: voucher.Number || voucher.DocNum || `DEP-${vIndex + 1}`,
                    voucherIndex: vIndex,
                    voucherTotal: Number(voucher.Total || 0),

                    // Series y correlativos
                    U_BPP_MDTDPaymentDefault: 40,
                    U_BPP_PTSCPaymentDefault: ''
                });
            }

        });

        if (perceptions?.length && paymentsSummary?.length) {
            $("#perceptionsModal").modal("show");
            return;
        }

        if (!newPerceptions?.length) {
            $("#continueCollectModal").modal("show");
        } else {
            setPerceptions(newPerceptions);
            $("#perceptionsModal").modal("show");
        }
    };

    const goBackPerceptions = (isConfirm = false) => {
        setPerceptions([]);
        if (isConfirm) {
            $("#continueCollectModal").modal("hide");
        }
        $("#perceptionsModal").modal("hide");
    }

    const getFormattedValue = (field, operation) => {
        let value = operation[field.key];

        if (field.needFormat) {
            return `${globalCurrency} ${FORMAT_NUMBER.new(value || 0)}`;
        }

        if (field.isDate) {
            return value || "";
        }

        return value || "";
    };

    const handleSameSerie = () => {
        setSameSerie(prev => {
            const newValue = !prev;

            if (newValue) { // Copiar valor del primero a todos
                setPerceptions(prevPerceptions => {
                    const firstValue = prevPerceptions?.[0]?.U_BPP_PTSCPaymentDefault || '';

                    return prevPerceptions?.map(p => ({
                        ...p,
                        U_BPP_PTSCPaymentDefault: firstValue
                    }));
                });
            }

            return newValue;
        });
    };

    const handleSerieChange = (value, index) => {
        const newValue = (value || '')?.slice(0, 4);

        setPerceptions(prev => {
            if (sameSerie) { // Mismo valor
                return prev.map(p => ({
                    ...p,
                    U_BPP_PTSCPaymentDefault: newValue
                }));
            } else { // Individual
                return prev.map((p, i) =>
                    i === index
                        ? { ...p, U_BPP_PTSCPaymentDefault: newValue }
                        : p
                );
            }
        });
    };

    const showPaymentsSummary = () => {
        $("#paymentsSummaryModal").modal("show");
    };

    const closePaymentsSummary = () => {
        if (paymentsSummary?.some(summary => summary?.status === 'error')) { // Existe un error - Posibilidad editar depósito
            $("#paymentsSummaryModal").modal("hide");
            $("#continueCollectModal").modal("hide");
        } else { // Se crearon todos los pagos - Finaliza el proceso
            closeModals(true);
        }
    };

    const openEditDeposit = (index) => {
        setSelectedVoucher(index);
        $("#editDepositModal").modal("show");
    };
    //#endregion

    //#region Render
    const renderInvoicesTotal = (amount) => {
        const showConversion = depositCurrency === 'USD' && currencyRate.date === DocDate && currencyRate.rate > 0;
        return (
            <div className="d-flex flex-wrap align-items-center">
                <span className="h5 font-weight-bold Depositos mb-0">
                    Total Facturas {showConversion ? 'USD' : globalCurrency} {FORMAT_NUMBER.new(showConversion && globalCurrency !== 'USD' ? amount / currencyRate.rate : amount)}
                </span>
                {showConversion && (
                    <span className="ml-3 pl-3 border-left text-info font-weight-bold">
                        SOL {FORMAT_NUMBER.new(globalCurrency === 'USD' ? amount * currencyRate.rate : amount)} · Tasa: {currencyRate.rate}
                    </span>
                )}
            </div>
        );
    };
    const renderDepositCard = (cVoucher, index) => (
        <div key={index} className="border rounded p-3 mb-3">
            <div className="row">
                <div className="col-12 col-md-3 col-lg-3 Depositos">
                    Depósito: {cVoucher.Number} <br />
                    Banco: {cVoucher.Bank}
                </div>
                <div className="col-12 col-md-3 col-lg-3 Depositos">
                    Fecha: {moment(cVoucher.Date).isValid() ? moment(cVoucher.Date).format("DD/MM/YYYY") : "--"} <br />
                    Moneda: {cVoucher.Currency}
                </div>
                <div className="col-12 col-md-3 col-lg-3 Depositos">
                    Cód. Aprobación: {cVoucher.U_RS_CODAPR || ""} <br />
                    Cuenta a mayor: {cVoucher.TransferAccount || ""}
                </div>
                <div className="col-12 col-md-3 col-lg-3 d-flex align-items-center font-weight-bold Depositos">
                    <div className="w-100 text-right">
                        {cVoucher.Currency} {FORMAT_NUMBER.new(cVoucher.TotalCurrency)}
                        {cVoucher.Currency === 'USD' &&
                            <div className="font-weight-normal">SOL {FORMAT_NUMBER.new(cVoucher.Total * (cVoucher.BaseRate || 1))} · Tasa: {cVoucher.ChangeRate_1}</div>
                        }
                        <i className="fa fa-trash-o" style={{ color: "#dc3545", margin: "1rem", cursor: 'pointer' }} onClick={() => removeDeposit(cVoucher, index)} />
                    </div>
                </div>
            </div>
        </div>
    );

    const renderDepositCardLink = (cVoucher, index) => {
        const isError = cVoucher?.paymentStatus === "error";
        return (
            <div key={index} className="border rounded p-3 mb-3" style={{ cursor: !cVoucher?.paymentStatus || isError ? 'pointer' : '', background: index === selectedVoucher ? "rgb(255, 248, 210)" : "" }} onClick={() => { if (cVoucher.paymentStatus !== "success") { setSelectedVoucher(index); } }}>
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-3 col-lg-3 Depositos">
                        Depósito: {cVoucher.Number} <br />
                        Banco: {cVoucher.Bank}
                    </div>
                    <div className="col-12 col-md-3 col-lg-3 Depositos">
                        Fecha: {moment(cVoucher.Date).isValid() ? moment(cVoucher.Date).format("DD/MM/YYYY") : "--"} <br />
                        Moneda: {cVoucher.Currency}
                    </div>
                    <div className="col-12 col-md-3 col-lg-3 Depositos">
                        Cód. Aprobación: {cVoucher.U_RS_CODAPR || ""} <br />
                        Cuenta a mayor: {cVoucher.TransferAccount || ""}
                    </div>
                    <div className="col-12 col-md-3 col-lg-3 d-flex align-items-center font-weight-bold">
                        <div className="w-100 text-right Depositos">
                            Total: {cVoucher.Currency} {FORMAT_NUMBER.new(cVoucher.TotalCurrency)} <br />
                            {cVoucher.Currency === 'USD' &&
                                <div className="font-weight-normal">SOL {FORMAT_NUMBER.new(cVoucher.Total * (cVoucher.BaseRate || 1))} · Tasa: {cVoucher.ChangeRate_1}</div>
                            }
                            Restante: {cVoucher.Currency} {FORMAT_NUMBER.new(depositRemaining(cVoucher))}
                        </div>
                    </div>
                    {isError &&
                        <div className="col-12 col-md-2 d-flex align-items-center justify-content-center">
                            <button className="btn btn-warning btn-sm" onClick={(e) => { e.stopPropagation(); openEditDeposit(index); }} > <i className="fa fa-edit mr-1" /> Editar </button>
                        </div>
                    }
                </div>
            </div>
        )
    };

    const renderOperation = (cOperation, index) => {

        if (cOperation?.Remaining <= 0) return null;

        const half = Math.ceil(operationFields?.length / 2);
        const leftFields = operationFields?.slice(0, half);
        const rightFields = operationFields?.slice(half);

        return (
            <div key={index} className="border rounded p-3 mb-3">
                <div className="row d-flex justify-content-center">
                    <div className="col-12 col-md-6 col-lg-6">
                        {leftFields.map((field, i) => (
                            <div key={i}>
                                <strong>{field.key === 'CashApplied' && Number(cOperation?.ObjType) === 203 ? 'Aplicado Anticipo' : field.key === 'CashTotal' && Number(cOperation?.ObjType) === 203 ? 'Anticipo' : field.label}: </strong>
                                {getFormattedValue(field, cOperation)}
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        {rightFields.map((field, i) => (
                            <div key={i}>
                                <strong>{field.key === 'CashApplied' && Number(cOperation?.ObjType) === 203 ? 'Aplicado Anticipo' : field.key === 'CashTotal' && Number(cOperation?.ObjType) === 203 ? 'Anticipo' : field.label}: </strong>
                                {getFormattedValue(field, cOperation)}
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="input-group justify-content-center">
                            <input
                                className="form-control text-right"
                                style={{ maxWidth: 200 }}
                                value={cOperation.Amount || ""}
                                onChange={({ target: { value } }) =>
                                    changeAmountOperation(
                                        value === "." ? "0."
                                            : isNaN(`${value || ""}`.replace(/,/g, ""))
                                                ? cOperation.Amount
                                                : `${value || ""}`.trim(),
                                        index
                                    )
                                }
                                onBlur={() =>
                                    changeAmountOperation(
                                        FORMAT_NUMBER.new(`${cOperation.Amount || ""}`.replace(/,/g, "")),
                                        index
                                    )
                                }
                            />
                            <div className="input-group-prepend">
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => addOperation(index)}
                                >
                                    <i className="fa fa-plus-circle mr-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderOperationLinked = (cOperation, index) => {
        const currentVoucher = voucherList[selectedVoucher];
        const isPaid = currentVoucher?.paymentStatus === "success";

        const half = Math.ceil(operationFields?.length / 2);
        const leftFields = operationFields?.slice(0, half);
        const rightFields = operationFields?.slice(half);

        return (
            <div key={`${cOperation.idSale}-${index}-${cOperation.CashApplied}`} className="border rounded p-3 mb-3">

                <div className="row d-flex justify-content-center">
                    <div className="col-12 col-md-6 col-lg-6">
                        {leftFields.map((field, i) => (
                            <div key={i}>
                                <strong>{field.key === 'CashApplied' && Number(cOperation?.ObjType) === 203 ? 'Aplicado Anticipo' : field.key === 'CashTotal' && Number(cOperation?.ObjType) === 203 ? 'Anticipo' : field.label}: </strong> {getFormattedValue(field, cOperation)}
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        {rightFields.map((field, i) => (
                            <div key={i}>
                                <strong>{field.key === 'CashApplied' && Number(cOperation?.ObjType) === 203 ? 'Aplicado Anticipo' : field.key === 'CashTotal' && Number(cOperation?.ObjType) === 203 ? 'Anticipo' : field.label}: </strong> {getFormattedValue(field, cOperation)}
                            </div>
                        ))}
                    </div>
                    {!isPaid && (
                        <div className="col-6 text-center mt-3">
                            <button
                                type="button"
                                className="btn btn-danger"
                                style={{ whiteSpace: "nowrap" }}
                                onClick={() => removeOperation(cOperation, index)}
                            >
                                <i className="fa fa-trash mr-2" />
                                Quitar
                            </button>
                        </div>
                    )}

                </div>
            </div>
        );
    };

    return (
        <>
            <div id="CollectDepositsModal" className="modal fade bd-example-modal-lg modal-open scroll" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-xl modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Registro de depósitos </span>
                        </div>
                        <div className="modal-body py-1">
                            <div className="row px-3">
                                {Number(perceptionsTotal ?? 0) > 0 ?
                                    <>
                                        <div className={`${depositCurrency === 'USD' ? 'col-12' : 'col-12 col-md-4 col-lg-4'} mb-2 Depositos`}>
                                            {renderInvoicesTotal(invoicesTotal)}
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-4 Depositos">
                                            <span className="ml-auto h5 font-weight-bold Depositos">{`Total Percepciones ${globalCurrency} ${FORMAT_NUMBER.new(perceptionsTotal)}`}</span>
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-4 Depositos">
                                            <span className="ml-auto h5 font-weight-bold Depositos">{`Total ${globalCurrency} ${FORMAT_NUMBER.new(Number(cashTotal))}`}</span>
                                        </div>
                                    </>
                                    :

                                    <div className={`${depositCurrency === 'USD' ? 'col-12' : 'col-12 col-md-4 col-lg-4'} mb-2 Depositos`}>
                                        {renderInvoicesTotal(cashTotal)}
                                    </div>
                                }
                                <div className="col-12 border rounded mb-2">
                                    <div className="row d-flex align-items-center justify-content-center mt-2">
                                        <div className="col-12 col-md-6 col-lg-4 mb-2 input-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>F. Documento</strong></span>
                                                </div>
                                                <input type="date" className="form-control" value={TaxDate} max='9999-12-31' readOnly />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4 mb-2 input-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>F. Contabilización</strong></span>
                                                </div>
                                                <input type="date" className="form-control" value={DocDate} onChange={SelectDocDate} disabled={validatingVoucher} max='9999-12-31' />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4 mb-2 input-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>F. Vencimiento</strong></span>
                                                </div>
                                                <input type="date" className="form-control" value={DocDueDate} onChange={SelectDocDueDate} max='9999-12-31' />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mb-2 input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Serie</strong></span>
                                            </div>
                                            <input type="text" className="form-control" disabled placeholder={SerieName} />
                                            <div className="input-group-append">
                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', }}
                                                    className="input-group-text"
                                                    onClick={OpenSeries}>
                                                    <i className="fa fa-list" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                        {checkOptions?.map(opt => (
                                            <div className="col-12 col-md-6 col-lg-3 mb-2 input-group" key={opt.value}>
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text font-weight-bold">
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                            id={`check${opt.value}`}
                                                            checked={currentCheck === opt.value}
                                                            onChange={() => {
                                                                if (currentCheck === opt.value) {
                                                                    setCurrentCheck(null);
                                                                } else {
                                                                    setCurrentCheck(opt.value);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    id={`input${opt.value}`}
                                                    value={opt.label}
                                                    readOnly
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-12 col-lg-10 border rounded p-3">
                                    <div className="row">
                                        <div className={`col-12 col-md-6 ${Sections['FlujoCaja'] ? 'mb-3' : ''}`}>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> N° Mov </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    value={voucher.number || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, number: `${value || ""}`.slice(0, 20) })} />
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Banco </span>
                                                </div>
                                                {/* <input
                                                    className="form-control"
                                                    value={voucher.bank || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, bank: `${value || ""}`.slice(0, 20) })} /> */}
                                                <select
                                                    name="select"
                                                    className="form-control"
                                                    style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                    value={voucher.bank || ''}
                                                    onChange={({ target: { value } }) =>
                                                        setVoucher({ ...voucher, bank: `${value || ""}`.slice(0, 20) })
                                                    }
                                                >
                                                    <option value="">Seleccionar</option>
                                                    {!!bankOptions && bankOptions?.map(bank => {
                                                        return (
                                                            <option value={bank.BankCode}>{bank.BankName || ''}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Fecha </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    value={voucher.date || ""}
                                                    onChange={({ target: { value } }) => setVoucher({ ...voucher, date: value })} />
                                            </div>
                                            <div className="input-group mb-3 mb-md-0">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Cuenta a mayor </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    value={voucher.TransferAccount || ""}
                                                    readOnly
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', }}
                                                        className="input-group-text"
                                                        onClick={() => openCuentaMayor(0, 2)}>
                                                        <i className="fa fa-list" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`col-12 col-md-6 ${Sections['FlujoCaja'] ? 'mb-3' : ''}`}>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Moneda </span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    value={voucher.currency || ""}
                                                    disabled={voucherList.length > 0 || validatingVoucher}
                                                    onChange={({ target: { value } }) => {
                                                        if (value === 'USD' && (currencyRate.date !== DocDate || currencyRate.rate <= 0)) {
                                                            return showAlert({ type: 'warning', message: 'No hay un tipo de cambio válido para la fecha de contabilización.' });
                                                        }
                                                        setVoucher({ ...voucher, currency: value });
                                                    }}
                                                >
                                                    <option value="" disabled>Seleccionar moneda</option>
                                                    <option value="PEN">PEN</option>
                                                    <option value="USD">USD</option>
                                                </select>
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Monto </span>
                                                </div>
                                                <input
                                                    className="form-control text-right"
                                                    value={voucher.total || ""}
                                                    onChange={({ target: { value } }) =>
                                                        setVoucher({
                                                            ...voucher, total: value === "." ? "0."
                                                                : isNaN(`${value || ""}`.replace(/,/g, "")) ? voucher.total
                                                                    : `${value || ""}`.trim()
                                                        })}
                                                    onBlur={() => setVoucher({ ...voucher, total: FORMAT_NUMBER.new(`${voucher.total || ""}`.replace(/,/g, "")) })} />
                                            </div>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Cód. Aprobación</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    value={voucher.U_RS_CODAPR || ""}
                                                    onChange={({ target: { value } }) =>
                                                        setVoucher({ ...voucher, U_RS_CODAPR: `${value || ""}`?.slice(0, 20) })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Flujo de caja */}
                                        {Sections['FlujoCaja'] &&
                                            <div className="col-12 col-md-12">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                                    </div>
                                                    {(
                                                        <Select
                                                            options={transferCFWOptions}
                                                            value={transferCFWOptions?.find(opt => opt.value === voucher?.transferCFWId) || null}
                                                            onChange={(event) => voucher?.TransferAccount && changeCFW(event, 1)}
                                                            placeholder={!voucher?.TransferAccount ? '' : "Escribe para buscar"}
                                                            isDisabled={!voucher?.TransferAccount || !voucher?.needTransferCFW}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                            styles={{
                                                                container: (base) => ({ ...base, flex: 1 }),
                                                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                                singleValue: (base) => ({ ...base, color: "#000" })
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-6 col-lg-2 mt-2 mb-2">
                                    <button type="button" className="btn btn-success w-100" onClick={validateVoucher} disabled={validatingVoucher}>
                                        <i className="fa fa-plus mr-2" /> <br />
                                        Agregar
                                    </button>
                                </div>

                                <div className="col-12 border rounded p-3 my-3 Depositos" style={{ maxHeight: 300, overflow: "auto" }}>
                                    {voucherList?.length ? voucherList.map(renderDepositCard)
                                        : "Sin depositos registrados"}
                                </div>

                                <div className="col-12 d-flex">
                                    <span className="ml-auto h5 font-weight-bold Depositos">{`Total Depósitos: ${depositCurrency} ${FORMAT_NUMBER.new(voucherList.reduce((acc, current) => acc + current.TotalCurrency, 0))}`}</span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={verifyVoucherList} className="btn btn-warning"> Continuar </button>
                            <button type="button" onClick={() => $("#cancelModal").modal("show")} className="btn btn-secondary"> Cancelar </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="LinkOperationsModal" className="modal fade bd-example-modal-xl modal-open" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-xl modal-open">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold">Relación de Depósitos - Documentos</span>
                        </div>
                        <div className="modal-body py-2">
                            <div className="row">
                                <div className="col-12">
                                    <div className="border rounded p-3 mb-3">
                                        <div className="w-100 d-flex align-items-center mb-3">
                                            <label className="h5 font-weight-bold mb-3"> Depósitos </label>
                                            {paymentsSummary?.length <= 0 && <button type="button" onClick={() => processCollectPayments()} className="btn btn-primary ml-auto"> Selección Automática </button>}
                                        </div>

                                        <div className="w-100 px-0 Depositos" style={{ height: 180, overflow: "auto" }}>
                                            {voucherList.map(renderDepositCardLink)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="border rounded p-2">
                                        <label className="h5 font-weight-bold mb-3">Documentos Disponibles</label>

                                        <div className="w-100 px-0 Depositos" style={{ height: 300, overflow: "auto" }}>
                                            {operations.map(renderOperation)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="border rounded p-2">
                                        <label className="h5 font-weight-bold mb-3"> {`Documentos Seleccionados${selectedVoucher >= 0 && voucherList?.[selectedVoucher]?.Number ? ` - Depósito ${voucherList?.[selectedVoucher]?.Number}` : ''}`} </label>

                                        <div className="w-100 px-0 Depositos" style={{ height: 300, overflow: "auto" }}>
                                            {!(Array.isArray(voucherList[selectedVoucher]?.operations) && voucherList[selectedVoucher]?.operations?.length) ? "Sin facturas"
                                                : voucherList[selectedVoucher].operations.map(renderOperationLinked)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {paymentsSummary?.length > 0 && <button type="button" onClick={showPaymentsSummary} className="btn btn-outline-dark"> Ver Resumen </button>}
                            <button type="button" onClick={checkPerceptions} className={`btn btn-${enableContinue ? "warning" : "dark"}`} disabled={!enableContinue}> Continuar </button>
                            {paymentsSummary?.length <= 0 && <button type="button" onClick={goBack} className="btn btn-secondary"> Volver </button>}
                            <button type="button" onClick={() => $("#cancelModal").modal("show")} className="btn btn-secondary"> Cancelar </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="continueCollectModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Confirmación </span>
                        </div>
                        <div className="modal-body py-2">
                            Las facturas sin relacionar no se considerarán al crear el pago. <br /> <br />
                            ¿Esta seguro que desea continuar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => payments()} className="btn btn-warning"> Continuar </button>
                            <button type="button" onClick={() => !perceptions?.length ? $("#continueCollectModal").modal("hide") : goBackPerceptions(true)} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="cancelModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="h4 font-weight-bold"> Confirmación </span>
                        </div>
                        <div className="modal-body py-2">
                            ¿Esta seguro que desea salir del registro de depósitos?
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => closeModals()} className="btn btn-warning"> Cerrar </button>
                            <button type="button" onClick={() => $("#cancelModal").modal("hide")} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="confirmBackModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar acción</h5>
                        </div>
                        <div className="modal-body">
                            ¿Seguro que deseas volver? <br />
                            <strong>Se descartarán todas las facturas seleccionadas.</strong>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => $("#confirmBackModal").modal("hide")} > Cancelar </button>
                            <button type="button" className="btn btn-danger" onClick={confirmGoBack} > Sí, volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="perceptionsModal" className="modal fade bd-example-modal-lg bgtransparent" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Percepciones</h5>
                        </div>
                        <div className="modal-body">
                            <>
                                <strong>Por favor, indique la serie del comprobante de percepción para cada depósito.</strong>
                                {perceptions?.length > 1 &&
                                    <div className="col-12 p-0 my-2 input-group">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text font-weight-bold">
                                                <input
                                                    type="checkbox"
                                                    style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                    id={`checkSameSerie`}
                                                    checked={sameSerie}
                                                    onChange={handleSameSerie}
                                                />
                                            </div>
                                        </div>
                                        <input
                                            className="form-control"
                                            id={`inputSameSerie`}
                                            value={'Misma Serie del documento'}
                                            readOnly
                                        />
                                    </div>
                                }
                                <div className="table-responsive">
                                    <table className="display mt-2" style={{ width: '100%', maxHeight: 600, overflow: "auto" }}>
                                        <thead className="table-header-yellow">
                                            <tr style={{ textAlign: "center" }}>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Depósito
                                                </td>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Tipo de Documento
                                                </td>
                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                    Serie del documento
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {perceptions?.map((row, index) => (
                                                <tr key={`${row.voucherNumber}-${index}`}>
                                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{row.voucherNumber}</td>
                                                    <td className="text-center">{row.U_BPP_MDTDPaymentDefault}</td>
                                                    <td className="text-center" style={{ width: '120px' }}>
                                                        <input
                                                            type="text"
                                                            value={row.U_BPP_PTSCPaymentDefault || ''}
                                                            maxLength={4}
                                                            className="form-control"
                                                            disabled={sameSerie && index !== 0}
                                                            onChange={({ target: { value } }) => handleSerieChange(value, index)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => { $("#perceptionsModal").modal("hide"); $("#continueCollectModal").modal("show"); }} className={`btn btn-${perceptions?.some(row => !row.U_BPP_PTSCPaymentDefault) ? "dark" : "warning"}`} disabled={perceptions?.some(row => !row.U_BPP_PTSCPaymentDefault)}> Continuar </button>
                            <button type="button" onClick={goBackPerceptions} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="editDepositModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{`Información del Depósito ${voucherList?.[selectedVoucher]?.Number ?? ''}`}</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">Cód. Aprobación</span>
                                        </div>
                                        <input
                                            className="form-control"
                                            value={voucherList?.[selectedVoucher]?.U_RS_CODAPR || ""}
                                            onChange={({ target: { value } }) => {
                                                const newValue = (value || "").slice(0, 20);
                                                setVoucherList(prev =>
                                                    prev.map((v, i) =>
                                                        i === selectedVoucher
                                                            ? { ...v, U_RS_CODAPR: newValue }
                                                            : v
                                                    )
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={`col-12 ${Sections['FlujoCaja'] ? 'mb-3' : ''}`}>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold"> Cuenta a mayor </span>
                                        </div>
                                        <input
                                            className="form-control"
                                            value={voucherList?.[selectedVoucher]?.TransferAccount || ""}
                                            readOnly
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', }}
                                                className="input-group-text"
                                                onClick={() => openCuentaMayor(0, 1)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Flujo de caja */}
                                {Sections['FlujoCaja'] &&
                                    <div className="col-12">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Flujo de caja</span>
                                            </div>
                                            {(
                                                <Select
                                                    options={transferCFWOptions}
                                                    value={transferCFWOptions?.find(opt => opt.value === voucherList?.[selectedVoucher]?.transferCFWId) || null}
                                                    onChange={(event) => voucherList?.[selectedVoucher]?.TransferAccount && changeCFW(event, 1, true)}
                                                    placeholder={!voucherList?.[selectedVoucher]?.TransferAccount ? '' : "Escribe para buscar"}
                                                    isDisabled={!voucherList?.[selectedVoucher]?.TransferAccount || !voucherList?.[selectedVoucher]?.needTransferCFW}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    menuPortalTarget={document.body}
                                                    noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                    styles={{
                                                        container: (base) => ({ ...base, flex: 1 }),
                                                        control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                        input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                        singleValue: (base) => ({ ...base, color: "#000" })
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning" onClick={() => { saveEdition() }} > Guardar </button>
                            <button type="button" onClick={() => { $("#editDepositModal").modal("hide"); }} className="btn btn-secondary"> Volver </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="paymentsSummaryModal" className="modal fade bd-example-modal-lg bgtransparent" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Resumen de Depósitos
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover text-center" style={{ width: '100%', maxHeight: 600, overflow: "auto" }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <th>Depósito</th>
                                            <th>N° Pago</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>No.Ref.de. cliente</th>
                                            <th>Estado</th>
                                            <th>Mensaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(paymentsSummary || [])?.length === 0 ? (
                                            <tr>
                                                <td colSpan="5">Sin información</td>
                                            </tr>
                                        ) : (
                                            paymentsSummary.map((row, index) => (
                                                <tr key={index}>
                                                    <td style={{ whiteSpace: 'nowrap' }}>{row.voucherNumber ?? ''}</td>
                                                    <td style={{ whiteSpace: 'nowrap' }}>{row.paymentDocNum ?? ''}</td>
                                                    <td style={{ whiteSpace: 'nowrap' }}>{row.hasPerception ? row.perceptionNumber ?? '' : ''}</td>
                                                    <td>
                                                        <span
                                                            className={`badge ${row.status === "success"
                                                                ? "badge-success"
                                                                : "badge-danger"
                                                                }`}
                                                        >
                                                            {row.status === "success"
                                                                ? "Procesado"
                                                                : "No procesado"}
                                                        </span>
                                                    </td>
                                                    <td>{row.paymentMessage ?? ''}</td>

                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={closePaymentsSummary} className="btn btn-secondary"> Cerrar </button>
                        </div>
                    </div>
                </div>
            </div>

            {showOpenSeriesModal && (
                <SeriesCreateModal
                    data={ModelCollect?.SerieArray ?? []}
                    selectSerie={SelectSeries}
                    cleanData={closeSeriesCreateModal}
                />
            )}

            {showAccountListModal &&
                <AccountListModal
                    data={accounts}
                    selectAccount={selectAccountList}
                    cleanData={closeAccountListModal}
                />
            }
        </>
    );
    //#endregion
}